export default function Normal({ headerAlignClasses, children }) {
    return (
        <div className={`container mx-auto flex h-full min-h-[220px] max-w-[800px] flex-col items-center justify-center py-10 text-center ${headerAlignClasses}`}>{children}</div>
    );
}
